import * as types from './constants';

export const handleServicesLink = status => ({
  type: types.HANDLE_SERVICES_LINK_LOADING,
  status
});

export const setServicesLinkErrors = errors => ({
  type: types.SET_SERVICES_LINK_ERRORS,
  errors
});

export const clearServicesLinkErrors = () => ({
  type: types.CLEAR_SERVICES_LINK_ERRORS
});